module.exports = __webpack_public_path__ + "static/img/ver-1.35ce26a5.png";